"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUser = void 0;
var react_1 = __importStar(require("react"));
var Sentry = __importStar(require("@sentry/browser"));
var firebase = __importStar(require("firebase/app"));
var dayjs_1 = __importDefault(require("dayjs"));
var gamification_1 = require("@21st-night/gamification");
var helpers_1 = require("../../helpers");
var FirebaseProvider_1 = require("../FirebaseProvider");
var _a = __read(helpers_1.createContext(), 2), hook = _a[0], Provider = _a[1];
var SET_USER_DATA = 'SET_USER_DATA';
var SET_DECKS = 'SET_DECKS';
var SET_NOTES = 'SET_NOTES';
var LOG_OUT = 'LOG_OUT';
var initialState = {
    decks: [],
    notes: [],
    loadingUser: true,
    loadingDecks: true,
    loadingNotes: true,
    recentStreak: [0, 0, 0, 0, 0, 0, 0],
    gold: 0,
    streakFreeze: false,
    onboarding: {
        completed: true,
        completedSteps: [],
        variant: 'FACT',
    },
};
function reducer(state, action) {
    switch (action.type) {
        case SET_USER_DATA:
            return __assign(__assign(__assign({}, state), action.data), { loadingUser: false });
        case SET_DECKS:
            return __assign(__assign({}, state), { decks: action.decks, loadingDecks: false });
        case SET_NOTES:
            return __assign(__assign({}, state), { notes: action.notes, loadingNotes: false });
        case 'SET_RECENT_STREAK':
            return __assign(__assign({}, state), { recentStreak: action.recentStreak });
        case LOG_OUT:
            return __assign(__assign({}, initialState), { loadingUser: false, loadingDecks: false });
        case 'SET_LOADING':
            return __assign(__assign({}, state), { loadingUser: action.loading, loadingDecks: action.loading });
        default:
            throw new Error();
    }
}
var UserProvider = function (_a) {
    var children = _a.children;
    var _b = FirebaseProvider_1.useFirebase(), db = _b.db, auth = _b.auth, userId = _b.userId;
    var _c = __read(react_1.useReducer(reducer, __assign(__assign({}, initialState), { id: userId || undefined })), 2), state = _c[0], dispatch = _c[1];
    var update = react_1.useCallback(function (data) {
        if (!userId) {
            throw new Error('User is not authenticated.');
        }
        return db.collection('users').doc(userId).update(data);
    }, [db, userId]);
    react_1.useEffect(function () {
        if (userId) {
            var streak = state.recentStreak;
            var lastThreeDays = streak.slice(-3);
            if (lastThreeDays[0] && !lastThreeDays[1] && !lastThreeDays[2]) {
                if (state.streakFreeze &&
                    state.streakFreezePurchasedAt &&
                    !dayjs_1.default().isSame(helpers_1.toDate(state.streakFreezePurchasedAt), 'day')) {
                    var yesterday = new Date();
                    yesterday.setDate(yesterday.getDate() - 1);
                    db.collection('users').doc(userId).collection('streak-days').add({
                        createdAt: yesterday,
                        isFreeze: true,
                    });
                    update({
                        streakFreeze: false,
                    });
                }
            }
        }
    }, [
        db,
        state.recentStreak,
        state.streakFreeze,
        state.streakFreezePurchasedAt,
        update,
        userId,
    ]);
    react_1.useEffect(function () {
        var snapshotListeners = [];
        function unsubscribeFromListeners() {
            snapshotListeners.forEach(function (unsubsribe) {
                unsubsribe();
            });
        }
        auth.onAuthStateChanged(function (user) {
            // User is signed in.
            if (user) {
                dispatch({ type: 'SET_LOADING', loading: true });
                var uid_1 = user.uid;
                var userRef_1 = db.collection('users').doc(uid_1);
                Sentry.configureScope(function (scope) {
                    scope.setUser({ email: user.email || '', id: uid_1 });
                });
                // Subscribe to user doc
                snapshotListeners.push(userRef_1.onSnapshot(function (snapshot) {
                    // Get the data from the snapshot turning
                    // Firestore Timestamps into date objects
                    var userData = snapshot.data();
                    if (userData) {
                        // Update UTC midnight offest if not set
                        // or it has changed.
                        var midnight = new Date();
                        midnight.setHours(0);
                        var midnightUtcHours = midnight.getUTCHours();
                        if (!userData.midnightUtcHours ||
                            userData.midnightUtcHours !== midnightUtcHours) {
                            userRef_1.update({ midnightUtcHours: midnightUtcHours });
                        }
                        // Set lastDailyReport timestamp to yesterday
                        // if missing.
                        if (!userData.lastDailyReport) {
                            var oneDayAgo = new Date();
                            oneDayAgo.setDate(oneDayAgo.getDate() - 1);
                            userRef_1.update({ lastDailyReport: oneDayAgo });
                        }
                        // The user doc contains only deck IDs
                        // as its decks value. We want to set
                        // the actual deck docs as the decks
                        // value, so we don't take them here.
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        var decks = userData.decks, other = __rest(userData, ["decks"]);
                        dispatch({
                            type: SET_USER_DATA,
                            data: __assign(__assign({}, other), { students: userData.students || {}, deckInvitations: userData.deckInvitations || [], id: snapshot.id, lastStreakIncrement: userData.lastStreakIncrement
                                    ? helpers_1.toDate(userData.lastStreakIncrement)
                                    : null, subscriptionEnd: userData.subscriptionEnd
                                    ? helpers_1.toDate(userData.subscriptionEnd)
                                    : false, studyPlan: userData.studyPlan
                                    ? {
                                        startDate: helpers_1.toDate(userData.studyPlan.startDate),
                                        testDate: helpers_1.toDate(userData.studyPlan.testDate),
                                        startWeekOn: userData.studyPlan.startWeekOn,
                                    }
                                    : undefined }),
                        });
                    }
                }));
                // Subscribe to user decks
                snapshotListeners.push(userRef_1
                    .collection('decks')
                    .orderBy('createdAt', 'desc')
                    .onSnapshot(function (snapshots) {
                    var decks = [];
                    snapshots.forEach(function (snapshot) {
                        var deckData = snapshot.data();
                        decks.push(helpers_1.deserializeDeckDocument(deckData, snapshot.id, uid_1));
                    });
                    dispatch({ type: SET_DECKS, decks: decks });
                }));
                // Subscribe to user notes
                snapshotListeners.push(db
                    .collection('notes')
                    .where('owner', '==', userId)
                    .onSnapshot(function (snapshots) {
                    var notes = [];
                    snapshots.forEach(function (snapshot) {
                        var noteData = snapshot.data();
                        notes.push(__assign(__assign({}, noteData), { id: snapshot.id }));
                    });
                    dispatch({ type: SET_NOTES, notes: notes });
                }));
                // Subscribe to user streak
                snapshotListeners.push(userRef_1
                    .collection('streak-days')
                    .limit(7)
                    .orderBy('createdAt', 'desc')
                    .onSnapshot(function (snapshot) {
                    var recentStreak = helpers_1.createRecentStreakDaysArray(snapshot.docs.map(function (doc) { return (__assign(__assign({ id: doc.id }, doc.data()), { createdAt: helpers_1.toDate(doc.data().createdAt) })); }), 7);
                    dispatch({ type: 'SET_RECENT_STREAK', recentStreak: recentStreak });
                }));
            }
            else {
                unsubscribeFromListeners();
                dispatch({ type: 'LOG_OUT' });
            }
        });
        return unsubscribeFromListeners;
    }, [auth, db, userId]);
    var deck = react_1.useCallback(function (id) {
        return state.decks.find(function (deck) { return deck.id === id; });
    }, [state.decks]);
    var updateLastActivityTimestamp = react_1.useCallback(function () {
        return update({ lastActivity: new Date() });
    }, [update]);
    var hasSeenMessage = react_1.useCallback(function (message) {
        return !!state.messaging && state.messaging.includes(message);
    }, [state.messaging]);
    var setMessageSeen = react_1.useCallback(function (message) {
        if (!userId) {
            throw new Error('User is not authenticated.');
        }
        if (!hasSeenMessage(message)) {
            return db
                .collection('users')
                .doc(userId)
                .update({
                messaging: firebase.firestore.FieldValue.arrayUnion(message),
            });
        }
        return new Promise(function (resolve) { return resolve(); });
    }, [hasSeenMessage, db, userId]);
    var toggleDailyReportEmailsForDeck = react_1.useCallback(function (deck) {
        if (deck.dailyReportEmail) {
            deck.update({
                dailyReportEmail: firebase.firestore.FieldValue.delete(),
            });
            var hasDeckWithDailyReportEmails_1 = false;
            state.decks.forEach(function (userDeck) {
                if (userDeck.id !== deck.id && userDeck.dailyReportEmail) {
                    hasDeckWithDailyReportEmails_1 = true;
                }
            });
            if (!hasDeckWithDailyReportEmails_1) {
                update({ dailyReportEmail: false });
            }
        }
        else {
            var oneDayAgo = new Date();
            oneDayAgo.setDate(oneDayAgo.getDate() - 1);
            deck.update({
                dailyReportEmail: true,
            });
            update({
                dailyReportEmail: true,
                // Needed so that the firestore query
                // finds this user
                lastDailyReportEmail: oneDayAgo,
            });
        }
    }, [state.decks, update]);
    var hasRole = react_1.useCallback(function (role) {
        if (!state.segmentation) {
            return false;
        }
        var segmentation = state.segmentation.values;
        if (role === 'tutor') {
            return ((segmentation[0] === 'tutoring' && segmentation[1] === 'tutor') ||
                state.segmentation.userType === 'tutor');
        }
        if (role === 'student') {
            return (segmentation[0] === 'self-studying' ||
                (segmentation[0] === 'tutoring' && segmentation[1] === 'student') ||
                state.segmentation.userType === 'student');
        }
        if (role === 'parent') {
            return ((segmentation[0] === 'tutoring' && segmentation[1] === 'parent') ||
                state.segmentation.userType === 'parent');
        }
        return false;
    }, [state.segmentation]);
    var incrementStreak = react_1.useCallback(function () {
        if (!userId) {
            return;
        }
        var newStreak = state.currentStreak || 0;
        // If the previous streak incerement was today
        // we don't need increment the streak, only the
        // last activity.
        if (state.lastStreakIncrement &&
            dayjs_1.default().isSame(state.lastStreakIncrement, 'date')) {
            update({ lastActivity: new Date() });
            return;
        }
        if (state.lastStreakIncrement && gamification_1.wasYesterday(state.lastStreakIncrement)) {
            // If the previous streak increment happened
            // yesterday, we increase the streak again today.
            newStreak += 1;
        }
        else {
            // The streak has not been updated today or
            // yesterday meaning that it has been broken
            // or has not yet been started (new user).
            // Set the streak to 1.
            newStreak = 1;
        }
        db.collection('users')
            .doc(userId)
            .collection('streak-days')
            .add({ createdAt: new Date() });
        var userUpdate = {
            currentStreak: newStreak,
            lastStreakIncrement: new Date(),
            lastActivity: new Date(),
        };
        if (newStreak % 3 === 0) {
            userUpdate.gold = state.gold || 0 + 3;
        }
        if (!state.statistics ||
            !state.statistics['longest-streak'] ||
            state.statistics['longest-streak'] < newStreak) {
            userUpdate['statistics.longest-streak'] = newStreak;
        }
        update(userUpdate);
    }, [
        db,
        state.currentStreak,
        state.gold,
        state.lastStreakIncrement,
        state.statistics,
        update,
        userId,
    ]);
    var purchaseTrophy = react_1.useCallback(function (trophyId, price) {
        return update({
            trophies: firebase.firestore.FieldValue.arrayUnion(trophyId),
            gold: firebase.firestore.FieldValue.increment(-price),
        });
    }, [update]);
    var purchaseStreakFreeze = react_1.useCallback(function () {
        if (!state.streakFreeze && state.gold && state.gold >= 9) {
            update({
                streakFreeze: true,
                streakFreezePurchasedAt: new Date(),
                gold: firebase.firestore.FieldValue.increment(-9),
            });
        }
    }, [state.gold, state.streakFreeze, update]);
    var addAchievement = react_1.useCallback(function (type, count) {
        if (!userId) {
            throw new Error('User is not authenticated.');
        }
        var achievement = {
            earnedAt: new Date(),
            type: type,
            count: count,
        };
        update({
            latestAchievement: achievement,
            gold: firebase.firestore.FieldValue.increment(+3),
        });
        return db
            .collection('users')
            .doc(userId)
            .collection('achievements')
            .add(achievement);
    }, [db, update, userId]);
    var incrementStatistic = react_1.useCallback(function (statistic) {
        var _a;
        return update((_a = {},
            _a["statistics." + statistic] = firebase.firestore.FieldValue.increment(1),
            _a));
    }, [update]);
    // If the user has a subscriptionEnd date
    // and that date is in the future, they have
    // an active subscription.
    var hasActiveSubscription = false;
    if (typeof state.subscriptionEnd !== 'undefined') {
        hasActiveSubscription =
            state.subscriptionEnd === false ||
                helpers_1.toDate(state.subscriptionEnd) > new Date();
    }
    return (react_1.default.createElement(Provider, { value: __assign(__assign({}, state), { addAchievement: addAchievement,
            deck: deck,
            hasActiveSubscription: hasActiveSubscription,
            hasRole: hasRole,
            hasSeenMessage: hasSeenMessage,
            incrementStatistic: incrementStatistic,
            incrementStreak: incrementStreak, latestStreakLength: state.currentStreak || 0, loading: state.loadingUser || state.loadingDecks, setMessageSeen: setMessageSeen,
            toggleDailyReportEmailsForDeck: toggleDailyReportEmailsForDeck,
            update: update, createdAt: helpers_1.toDate(state.createdAt || null), updateLastActivityTimestamp: updateLastActivityTimestamp,
            purchaseStreakFreeze: purchaseStreakFreeze,
            purchaseTrophy: purchaseTrophy }) }, children));
};
exports.useUser = hook;
exports.default = UserProvider;
//# sourceMappingURL=UserProvider.js.map